var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-library"},[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('course-by-self')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }